import BasePage from '../../components/base-page/base-page';
import BlogSearch from '../../components/search/search';
import Share from '../../../shared/utils/share/share';
import SideScrollingBanner from '../../components/side-scrolling-banner/side-scrolling-banner';
import defineBlogAppBannerElement from '../../components/blog-app-banner/blog-app-banner';
import defineWebAssistantPopup from '../../components/web-assistant-popup/web-assistant-popup';
import GoUpButton from '../../components/go-up-button/go-up-button';

import analytics, { events } from '../../../shared/analytics';

import './post.scss';

class PostPage extends BasePage {
  ui = {
    articleTitle: '.js-article-title',
    searchInput: '.js-search-input',
    goUpButton: '.js-go-up-button',
  }

  uiCollections = {
    contentBannerButton: '.js-promo-banner-cta',
    appBannerButton: 'blog-app-banner',
    useCaseBannerLink: '.use-case-banner a', // choose all links inside use-case-banner that's created on blog
  }

  events = {
    'click @uiCollections.contentBannerButton': 'handleContentBannerButtonClick',
    'click @uiCollections.appBannerButton': 'handleAppBannerButtonClick',
    'click @uiCollections.useCaseBannerLink': 'handleUseCaseBannerLinkClick',
  }

  onInit() {
    super.onInit();

    if (this.ui.searchInput) {
      new BlogSearch().init();
    }
    new Share().init();
    new SideScrollingBanner().init();
    if (this.ui.goUpButton) {
      new GoUpButton(this.ui.articleTitle).init();
    }

    defineBlogAppBannerElement();
    defineWebAssistantPopup();
  }

  handleContentBannerButtonClick = (e) => {
    e.preventDefault();
    const { textContent: eventLabel } = e.target.closest('.promo-banner')?.querySelector('.promo-banner__description-header');

    this.signupModal.open();

    analytics.trackEvent({
      ...events.BLOG_BANNER_CLICK,
      eventLabel,
      eventLabel2: 'promo-banner',
    });
  }

  handleAppBannerButtonClick = (e) => {
    const eventLabel = e.currentTarget.getAttribute('name');

    analytics.trackEvent({
      ...events.BLOG_BANNER_CLICK,
      eventLabel,
      eventLabel2: 'app-banner',
    });
  }

  handleUseCaseBannerLinkClick = (e) => {
    const { textContent: eventLabel } = e.currentTarget;

    analytics.trackEvent({
      ...events.BLOG_BANNER_CLICK,
      eventLabel,
      eventLabel2: 'use-case-banner',
    });
  }
}

export default PostPage;

PostPage.initOnDomLoaded();
